import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'
import { useQueryClient } from '@tanstack/react-query'

const useDeletePlatformAppClientMutation = createMutationHook(
  PlatformAppsApiClient.deletePlatformAppClient,
  {
    mutationKey: ['deletePlatformAppClient'],
  },
)

export const useDeletePlatformAppClient = () => {
  const queryClient = useQueryClient()
  const { deletePlatformAppClientMutation } = useDeletePlatformAppClientMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['platformAppClients'] })
    },
  })

  return {
    deletePlatformAppClient: deletePlatformAppClientMutation.mutate,
    isLoading: deletePlatformAppClientMutation.isLoading,
  }
}
